import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { ResponsiveService } from '@services/responsive';
import { Title } from '@shared/components/title/model';
import { FontSizePipe, GetClassPipe } from '@shared/components/title/pipe';

@Component({
  selector: 'app-title',
  styleUrl: './title.component.scss',
  templateUrl: './title.component.html',
  imports: [GetClassPipe, NgClass, GetClassPipe, FontSizePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitleComponent {
  readonly titles = input.required<Title[]>();
  readonly breakpoints = inject(ResponsiveService).breakpoints;
}
